import { excludePredictionsLegends } from "components/Utils/ChartsDataUtils";
import React, { useState, useEffect, useRef } from "react";

import { getTextWidth } from "./../../Utils/Utils";

const QuentElemetsStart = 10;

const getObjTrue = (data) => {
  const obj = {};
  data.forEach((el) => (obj[el.name] = true));
  return obj;
};
const getObjFalse = (data) => {
  const obj = {};
  data.forEach((el) => (obj[el.name] = false));
  return obj;
};
const getCheckList = (data) => {
  const obj = {};
  data.forEach((el) => (obj[el.name] = el.value));
  return obj;
};
const getQuentEl = (data) => {
  const obj = {};
  data.forEach(
    (el) =>
      (obj[el.name] =
        el.value.length >= QuentElemetsStart
          ? QuentElemetsStart
          : el.value.length)
  );
  return obj;
};

// const More = ({ more }) => (
//   <div className="query-builder-legend__more mt-2" onClick={more}>
//     MORE
//   </div>
// );

const Legend = (props) => {
  const [state, setState] = useState({
    myValue: "",
  });

  useEffect(() => {
    setState({
      ...state,
      isOpened: getObjTrue(props.data),
      isAllSelected: getObjTrue(props.data),
      indeterminate: getObjFalse(props.data),
      checkList: getCheckList(props.data),
      quentEl: getQuentEl(props.data),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data]);

  const refLegend = useRef();

  const CheckBox = ({
    friendlyName,
    value,
    color,
    selected,
    onCheck,
    indeterminate,
  }) => {
    return (
      <>
        {refLegend.current &&
        refLegend.current.offsetWidth < getTextWidth(friendlyName) * 1.05 ? (
          <span className="hover-custom-title"></span>
        ) : (
          ""
        )}
        <label custom-title={friendlyName}>
          <input
            type="checkbox"
            checked={selected || false}
            onChange={onCheck}
            value={value}
            ref={(el) => el && (el.indeterminate = indeterminate)}
          />
          <span
            className={"custom-check" + (indeterminate ? " indeterminate" : "")}
            style={{ backgroundColor: color }}
          ></span>
          <span className="text-capitalize">{friendlyName}</span>
        </label>
      </>
    );
  };

  const CheckBoxList = ({ list, isCheckedAll, onCheck, indeterminate }) => {
    return (
      <ul className="query-builder-legend__checkbox-list">
        {list.map((el, i) => {
          if (el.name === "select_all") {
            return (
              <li key={i}>
                <CheckBox
                  friendlyName={el.friendlyName}
                  value={el.name}
                  color={el.color}
                  selected={isCheckedAll}
                  onCheck={(e) => onCheck("select_all", e.target.checked)}
                  indeterminate={indeterminate}
                  refLegend={refLegend}
                />
              </li>
            );
          } else
            return (
              <li ref={refLegend} key={i}>
                <CheckBox
                  friendlyName={el.friendlyName}
                  value={el.name}
                  color={el.color}
                  selected={el.checked}
                  onCheck={(e) => onCheck(el.name, e.target.checked)}
                  refLegend={refLegend}
                />
              </li>
            );
        })}
      </ul>
    );
  };

  const Dropdown = ({
    data: { value: list, name: listName, friendlyName: listFriendlyName },
    checkList,
    indeterminate,
    isAllSelected,
    quentEl,
    isOpened,
    myValue,
    onCheckBoxChange,
    toggleState,
    growthQuentEl,
  }) => {
    const filterWord = myValue.toLowerCase();

    const filteredList = list
      .filter((d) =>
        filterWord
          ? d.friendlyName.toLowerCase().indexOf(filterWord) >= 0
          : true
      )
      .map(
        (elList) =>
          checkList[listName].find((d) => elList.name === d.name) || {}
      )
      .slice(0, quentEl[listName]);

    const checkBoxList = (
      <CheckBoxList
        list={filteredList}
        isCheckedAll={isAllSelected[listName]}
        onCheck={(checkName, checked) =>
          onCheckBoxChange(checkName, checked, listName)
        }
        indeterminate={indeterminate[listName]}
      />
    );

    const More = ({ more }) => (
      <div className="query-builder-legend__more mt-2" onClick={more}>
        MORE
      </div>
    );

    const more = () => {
      return quentEl[listName] >=
        list.filter((d) =>
          filterWord
            ? d.friendlyName.toLowerCase().indexOf(filterWord) >= 0
            : true
        ).length ? null : (
        <More more={() => growthQuentEl(listName, list.length)} />
      );
    };

    const dropdownEl = isOpened[listName] ? (
      <div className="list-dropdown">
        {checkBoxList}
        {more()}
      </div>
    ) : null;

    const dropdown = (
      <div className="query-builder-legend__dropdown">
        <div
          className={`title-dropdown pr-2 ${
            isOpened[listName] ? "opened-dropdown" : "closed-dropdown"
          }`}
          onClick={() => toggleState(listName)}
        >
          {listFriendlyName}
        </div>
        {dropdownEl}
      </div>
    );

    return listName !== "metrics"
      ? checkList["metrics"].find((el) => el.name === listName).checked
        ? dropdown
        : null
      : dropdown;
  };

  const onChange = (event) => {
    setState({ ...state, myValue: event.target.value });
  };

  const onCheckBoxChange = (checkName, checked, listName) => {
    const { checkList, isAllSelected, indeterminate } = state;

    const isAllChecked = checkName === "select_all" && checked;
    const isAllUnChecked = checkName === "select_all" && !checked;

    const _checkList = {
      ...checkList,
      [listName]: checkList[listName].map((el) => {
        if (isAllChecked || el.name === checkName) {
          return { ...el, checked };
        } else if (isAllUnChecked) {
          return { ...el, checked: false };
        }
        return el;
      }),
    };
    const _isAllSelected = {
      ...isAllSelected,
      [listName]:
        _checkList[listName].findIndex(
          (el) => el.checked === false && el.name !== "select_all"
        ) === -1 || isAllChecked,
    };

    const _indeterminate = {
      ...indeterminate,
      [listName]:
        _checkList[listName].findIndex(
          (el) => el.checked === false && el.name !== "select_all"
        ) !== -1 &&
        _checkList[listName].findIndex(
          (el) => el.checked === true && el.name !== "select_all"
        ) !== -1,
    };

    _checkList[listName][0].checked = _isAllSelected[listName]; // select_all

    setState({
      ...state,
      checkList: _checkList,
      isAllSelected: _isAllSelected,
      indeterminate: _indeterminate,
    });

    props.onChangeSelection(_checkList);
  };

  const toggleState = (listName) => {
    const { isOpened } = state;
    setState({
      ...state,
      isOpened: { ...isOpened, [listName]: !isOpened[listName] },
    });
  };

  const growthQuentEl = (listName, length) => {
    const { quentEl } = state;
    setState({
      ...state,
      quentEl: {
        ...quentEl,
        [listName]: Math.min(quentEl[listName] + 20, length),
      },
    });
  };

  const InputSearch = (
    <input
      className="filters__input"
      value={state.myValue}
      onChange={onChange}
      placeholder="Search For"
    />
  );

  const listContent = excludePredictionsLegends(props.data);
  const content = listContent.map((d, i) => {
    return (
      <Dropdown
        key={i}
        data={d}
        checkList={state.checkList}
        isAllSelected={state.isAllSelected}
        indeterminate={state.indeterminate}
        onCheckBoxChange={onCheckBoxChange}
        quentEl={state.quentEl}
        isOpened={state.isOpened}
        myValue={state.myValue}
        toggleState={toggleState}
        growthQuentEl={growthQuentEl}
      />
    );
  });

  return (
    <div className="query-builder-legend" ref={refLegend}>
      {InputSearch}
      {state.checkList && Object.keys(state.checkList).length ? content : null}
    </div>
  );
};

export default Legend;
